import { Icon } from 'components/Icon';
import { policySummary, type FactorApplicationPolicy } from './form';
import * as styles from './FactorPolicyIndicator.css';

export function FactorPolicyIndicator({
  policy,
  side,
}: {
  policy: FactorApplicationPolicy | null;
  side: 'Client' | 'Provider';
}) {
  if (policy === null) return null;

  const description = `${side} auto factor policy: ${
    policy.exclude_auto_kind.length === 0 ? 'No exclusions; stops policy fallback.' : policySummary(policy)
  }`;
  return (
    <span className={styles.indicator} role="img" aria-label={description} title={description}>
      <Icon icon="bolt-auto" color="danger" />
    </span>
  );
}
